import IframeActivity from "./IframeActivity";

export default function WealthLeakCalculator() {
    return (
        <IframeActivity
            src="/activities/wealth-leak-calculator/index.html"
            title="Wealth Leak Calculator"
        />
    );
}